<template>
	<div :class="{ 
    'bg-blue-100 p-6' : true, 
    'border-2 border-blue-500' : isCurrentPlan, 
    'border-2 border-blue-200' : !isCurrentPlan }">

    <div class="uppercase text-xl text-center font-thin">
      pro

      <template v-if="isCurrentPlan">
        <svg width="20" height="20" stroke-width="3" class="ml-4 inline -mt-2 text-green-500" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#check-circle"/>
        </svg>
      </template>
    </div>

    <div class="mt-4 text-center text-base text-gray-900">
      $88 / month
    </div>

    <div class="mt-2 text-sm text-center text-gray-700">Including GST</div>

    <div class="mt-8 text-center">
      <template v-if="subscription != null">
        <template v-if="subscription.name == 'pro'">
          <template v-if="subscription.on_grace_period">
            <a href="#" 
              class="bg-blue-500 hover:bg-blue-600 text-white text-xs font-semibold uppercase block py-4" 
              @click.prevent="resume()">Resume subscription</a>
          </template>

          <template v-else>
            <div class="bg-green-600 text-white text-xs font-semibold uppercase block py-4">
              Currently on this plan
            </div>
          </template>
        </template>

        <template v-else>
          <a href="#" 
            class="bg-blue-500 hover:bg-blue-600 text-white text-xs font-semibold uppercase block py-4" 
            @click.prevent="switchPlan(plan)">Change to Pro Plan</a>
        </template>
      </template>

      <template v-else>
        <a href="#" 
          class="bg-blue-500 hover:bg-blue-600 text-white text-xs font-semibold uppercase block py-4" 
          @click.prevent="subscribe(plan)">Start Now</a>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    props : {
      subscription : {
        type    : Object,
        required: false
      },

      plan : {
				type    : Object,
				required: true
      },

      subscribe : {
				type    : Function,
				required: true
      },

      switchPlan : {
        type    : Function,
        required: true
      }
    },

    computed : {
      isCurrentPlan() {
        return this.subscription != null && this.subscription.name == 'Pro Plan' && !this.subscription.on_grace_period
      }
    }
  }
</script>